import { authService } from './auth-service';

export interface ScanSubmission {
  id: string;
  status: 'PROCESSED' | 'OCR_ERROR' | 'ERROR';
  extractedId: string | null;
  extractedPhone: string | null;
  extractedToken: string | null;
}

async function submitOrgScan(orgId: string, blob: Blob): Promise<ScanSubmission> {
  const token = authService.getToken();
  const form = new FormData();
  form.append('file', blob, 'ticket.jpg');
  const res = await fetch(`/api/ticket/v1/org/${encodeURIComponent(orgId)}/scan`, {
    method: 'POST',
    headers: token ? { Authorization: `Bearer ${token}` } : {},
    body: form,
  });
  if (!res.ok) {
    const text = await res.text().catch(() => res.statusText);
    throw new Error(text || `HTTP ${res.status}`);
  }
  return res.json();
}

async function submitAnonScan(token: string, blob: Blob): Promise<ScanSubmission> {
  const form = new FormData();
  form.append('file', blob, 'ticket.jpg');
  const res = await fetch(`/api/ticket/v1/public/scan/${encodeURIComponent(token)}`, {
    method: 'POST',
    body: form,
  });
  if (!res.ok) {
    const text = await res.text().catch(() => res.statusText);
    throw new Error(text || `HTTP ${res.status}`);
  }
  return res.json();
}

export const scanService = { submitOrgScan, submitAnonScan };